import { ACTIONS_RECIPIENT } from '../_constants/notificationRecipient.constants';

const initialState = {
  byId: {},
};

export function notificationRecipientReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_RECIPIENT.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_RECIPIENT.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_RECIPIENT.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default notificationRecipientReducer;
